import { render, staticRenderFns } from "./zzl-table.vue?vue&type=template&id=2e5e5964"
import script from "./zzl-table.vue?vue&type=script&lang=js"
export * from "./zzl-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports